export default "__VITE_PUBLIC_ASSET__280b2596__"